import state from "./modulePresentationState.js";
import mutations from "./modulePresentationMutations.js";
import actions from "./modulePresentationActions.js";
import getters from "./modulePresentationGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
